import { render } from "./ChatUserList.vue?vue&type=template&id=e8878678&ts=true"
import script from "./ChatUserList.vue?vue&type=script&lang=ts"
export * from "./ChatUserList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ChatUserList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8878678"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8878678', __exports__)) {
    api.reload('e8878678', __exports__)
  }
  
  module.hot.accept("./ChatUserList.vue?vue&type=template&id=e8878678&ts=true", () => {
    api.rerender('e8878678', render)
  })

}


export default __exports__